import { sortBy } from 'lib/array/arrayUtils'
import { BENEFIT_ICONS, TIER_PROGRESSION_BENEFIT_ORDER } from 'loyalty/constants/tierProgressionBenefits'

function getTierBenefitsForProgression(
  loyaltyConfig: App.LoyaltyConfig | undefined,
  tier: App.LoyaltyTier,
): Array<App.LoyaltyRegionTierBenefit> {
  if (!loyaltyConfig?.regionTierBenefits) return []
  const benefits = loyaltyConfig.regionTierBenefits[tier] ?? []
  const filteredBenefits = benefits.filter(benefit =>
    BENEFIT_ICONS[benefit.code] !== null &&
    loyaltyConfig.regionEnabledBenefits[benefit.code],
  )
  return sortBy(filteredBenefits, (benefit) => {
    const order = TIER_PROGRESSION_BENEFIT_ORDER.indexOf(benefit.code)
    return order === -1 ? TIER_PROGRESSION_BENEFIT_ORDER.length : order
  }, 'asc')
}

export default getTierBenefitsForProgression
